import React, {useContext, useState} from 'react';
import {fetchSendersList, runScript} from "../../services";
import Fetch from "../../Elements/Fetch";
import FormGroupRowSender from "../../Elements/FormGroupRowSender";
import useSubmittingButton from "../../hooks/useSubmittingButton";
import {Col, Row} from "reactstrap";
import {ModalContext} from "../../Modal/ModalProvider";

const MigrateTransactionsExport = () => {

    const [senderId, setSenderId] = useState([]);

    const {errorMessage, loader, SubmittingButton} = useSubmittingButton();
    const {showModal} = useContext(ModalContext);

    const handleSubmit = async () => {
        const response = await runScript('MigrateTransactionsExport', {
            senderId: senderId
        });

        if (response.status === 200) {
            const data = await response.json();

            showModal({
                type: 'download',
                exportId: data.id,
            });
        }
        else {
            throw new Error(`${response.status}: ${response.statusText}. Contact a site administrator. This error probably won't go away by itself.`);
        }
    };

    const disabled = senderId == null;

    return (
        <>
            <h4>Migrate Transactions Export</h4>

            {errorMessage}

            <form style={{maxWidth: 600}}>
                <Fetch fetchFunction={fetchSendersList} className="form-group">
                    {senderList => (
                        <FormGroupRowSender
                            label="Sender"
                            value={senderId}
                            onChange={setSenderId}
                            senders={senderList}
                        />
                    )}
                </Fetch>

                <Row form className="align-items-center">
                    <Col xs="auto">
                        <SubmittingButton onClick={handleSubmit} disabled={disabled}>Submit</SubmittingButton>
                    </Col>
                    <Col xs="auto">
                        {loader}
                    </Col>
                </Row>
            </form>
        </>
    );
};

export default MigrateTransactionsExport;
